import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit'

import { forbiddenDetected } from '~/shell/redux/forbiddenSlice'

/**
 * Flags a server-enforced 403 from any RTK Query request.
 *
 * Authorization is enforced by the backend, so a user who is signed in but not
 * entitled to the requested data gets a 403 rather than a client-side block.
 * This middleware watches for that rejected query and dispatches
 * `forbiddenDetected`, which the app layout turns into a redirect to an
 * unauthorized page. Fires for any query the backend rejects with a 403.
 */
export const forbiddenMiddleware: Middleware = (api) => (next) => (action) => {
  const isRejectedAction =
    isRejectedWithValue(action) &&
    typeof action.payload === 'object' &&
    action.payload !== null &&
    'status' in action.payload &&
    typeof action.payload.status === 'number' &&
    action.payload.status === 403

  if (isRejectedAction) {
    api.dispatch(forbiddenDetected())
  }
  return next(action)
}
